import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
    return {
        navItem: {
            height: 37,
            marginTop: 6,
            marginBottom: 2,
            borderRadius:4,
            cursor: 'pointer',
            textDecoration: 'none !important',
            paddingLeft: 24 ,
            '&.nav-item-header': {
                textTransform: 'uppercase',
            },
            '&.active': {
                backgroundColor:theme.palette.secondary.main,
                pointerEvents: 'none',
                transition: '.15s cubic-bezier(0.4,0.0,0.2,1)',
                '& .nav-item-text': {
                    color: "#fff",
                },
                '& .nav-item-icon': {
                    color: "#fff",
                },
            },

            '&:hover, &:focus': {
                '& .nav-item-text': {
                    color: theme.palette.secondary.main
                },

                '& .nav-item-icon': {
                    color:  theme.palette.secondary.main
                },

                '& .nav-item-icon-arrow': {
                    color: theme.palette.secondary.main
                },
            },
            '& .nav-item-icon': {
                color: "#ececec",
            },
            '& .nav-item-icon.child': {
                color: "#afafaf",
            },
            '& .nav-item-text': {
                color: "#ececec",
            },'& .nav-item-text.child': {
                color: "#afafaf",
            },
        },
        listIcon: {
            fontSize: 18,
            [theme.breakpoints.up('xl')]: {
                fontSize: 20,
            },
        },
        listItemText: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
    };
});
export default useStyles;

